module.exports = __webpack_public_path__ + "img/vki.18fbaa42.png";